import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
// import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { SectorsComponent } from './sectors/sectors.component';
import { PartnersComponent } from './partners/partners.component';
import { ShowroomComponent } from './showroom/showroom.component';
import { ContactComponent } from './contact/contact.component';
import { MenuService } from './menu.service';
import { ResidentialComponent } from './sectors/residential/residential.component';
import { YachtComponent } from './sectors/yacht/yacht.component';
import { ComercialComponent } from './sectors/comercial/comercial.component';
import { HospitalityComponent } from './sectors/hospitality/hospitality.component';
import { SmartComponent } from './sectors/smart/smart.component';

const appRoutes: Routes = [
  // { path: '/', component: HomeComponent },
  { path: 'index', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'partners', component: PartnersComponent },
  { path: 'showroom', component: ShowroomComponent },
  { path: 'contact-us', component: ContactComponent },
  { path: 'residential', component: ResidentialComponent },
  { path: 'yacht', component: YachtComponent },
  { path: 'commercial', component: ComercialComponent },
  { path: 'hospitality', component: HospitalityComponent },
  { path: 'smart-cities', component: SmartComponent },
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full'
  },
  { path: '**', component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    SectorsComponent,
    PartnersComponent,
    ShowroomComponent,
    ContactComponent,
    ResidentialComponent,
    YachtComponent,
    ComercialComponent,
    HospitalityComponent,
    SmartComponent
  ],
  imports: [
    BrowserModule,
    // AppRoutingModule,
    RouterModule.forRoot(
      appRoutes,
     // { enableTracing: true }  <-- debugging purposes only
    )
  ],
  providers: [MenuService],
  bootstrap: [AppComponent]
})
export class AppModule { }
